/* @flow */
import * as React from 'react';
import Redirect from 'components/Redirect';

type Props = {
  // passed in from AdminSettingsLayout
  groupCode: string,
  orgType: string,
};

export class AdminAdminsRedirect extends React.Component<Props> {
  render() {
    const stub = `/classes/${this.props.groupCode}/settings/organization/administrators/`;

    if (this.props.orgType === 'District') {
      return <Redirect to={`${stub}district`} />;
    }

    return <Redirect to={`${stub}school`} />;
  }
}

export default AdminAdminsRedirect;
